import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function CourseNavigation(props) {
  const {
    canNavigatePrev,
    canNavigateNext,
    showPrev,
    showNext,
    textPrev,
    textNext,
    handleNavigationPrev,
    handleNavigationNext,
  } = props;

  const navigationClass = isBack =>
    cx('btn', 'm-btn--pill', 'btn-secondary', 'navigation-button', {
      'navigation-back': isBack,
      'navigation-next': !isBack,
    });

  return (
    <div className="course-navigation">
      {showPrev && (
        <button
          disabled={!canNavigatePrev}
          onClick={handleNavigationPrev}
          type="button"
          className={navigationClass(true)}
        >
          <i className="la la-angle-left m--font-dynamic" />
          {textPrev}
        </button>
      )}
      {showNext && (
        <button
          disabled={!canNavigateNext}
          onClick={handleNavigationNext}
          type="button"
          className={navigationClass(false)}
        >
          {textNext}
          <i className="la la-angle-right m--font-dynamic" />
        </button>
      )}
    </div>
  );
}

CourseNavigation.propTypes = {
  canNavigatePrev: PropTypes.bool,
  canNavigateNext: PropTypes.bool,
  showPrev: PropTypes.bool,
  showNext: PropTypes.bool,
  textPrev: PropTypes.string,
  textNext: PropTypes.string,
  handleNavigationPrev: PropTypes.func,
  handleNavigationNext: PropTypes.func,
};

CourseNavigation.defaultProps = {
  canNavigatePrev: true,
  canNavigateNext: true,
  showPrev: true,
  showNext: true,
  textPrev: '',
  textNext: '',
  handleNavigationPrev: () => null,
  handleNavigationNext: () => null,
};
